module.exports = "/images/search.svg";